import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isStringNotEmpty } from "../utils/objectUtils";

export const createTheOfferSession = async (cid, sub1, sub2, sub3, sub4, sub5) => {
    if (isStringNotEmpty(cid)) {
        // bounded: this runs inside TrackingService.initialize(), and a slow upstream would
        // otherwise hold siteVisit creation (and the analytics queue) for the whole session
        const func = httpsCallable(functions, "createtheoffersession", { timeout: 10000 });

        const res = await func({ cid: cid, sub1: sub1, sub2: sub2, sub3: sub3, sub4: sub4, sub5: sub5 });

        console.log(res.data);
        return res.data;
    }

    return null;
};